import { req, Request } from '../Repository';
import { setFullToken, checkTokenHeaders } from '../apiHelper';

const resource = '/xdent/forms';

export default {
    getFormById: async (id, clientId, locationId, token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.get(`${resource}/${id}?clientId=${clientId}&locationId=${locationId}`, token);
        });
        return data;
    },

    getAllFormsByLocation: (clientId, token) => {
        return req(token).then((token) => {
            return Request.get(`${resource}?clientId=${clientId}`, token);
        });
    }, // Zeptat se Máry

    createFormPDF: (clientId, locationId, html, token) => {
        return req(token).then((token) => {
            return Request.put(
                `${resource}`,
                {
                    clientId,
                    locationId,
                    html,
                },
                token
            );
        });
    },
    getPdf: (idForm, isIos = false, token) => {
        return req(token).then((token) => {
            if (!isIos) {
                return Request.get(`${resource}/getpdf?idForm=${idForm}`, {
                    responseType: 'blob',
                    headers: {
                        Authorization: token.headers.Authorization,
                        Accept: 'application/pdf',
                    },
                });
            } else {
                return Request.get(`${resource}/getpdf?idForm=${idForm}&isIos=true`, token);
            }
        });
    },
    // Not actually needed, PDF is generated and saved to DB when form is saved
    // generatePdf: async (idForm, token = JSON.parse(localStorage.getItem('token'))) => {
    //     let { data } = await req(token).then((token) => {
    //         return Request.get(`${resource}/getPdfV2?idForm=${idForm}`, {
    //             responseType: 'blob',
    //             headers: {
    //                 Authorization: token.headers.Authorization,
    //                 Accept: 'application/pdf',
    //             },
    //         });
    //     });
    //     return data;
    // },
    saveForm: (model, token) => {
        return req(token).then((token) => {
            return Request.post(`${resource}/saveForm`, JSON.stringify(model), token);
        });
    },
    insertForm: async (payload, token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.post(`${resource}/insertForm`, JSON.stringify(payload), token);
        });
        return data;
    },
    updateForm: async (payload, token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.put(`${resource}/updateForm`, JSON.stringify(payload), token);
        });
        return data;
    },
    getPopulatedForms: async (clientId, token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.get(`${resource}/getpopulatedforms?idClient=${clientId}`, token);
        });
        return data;
    },
    getSavedFormById: async (id, idClient, token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.get(`${resource}/getsavedformbyid?idForm=${id}&idClient=${idClient}`, token);
        });
        return data;
    },
    deleteFilledItemById: (id, token) => {
        return req(token).then((token) => {
            return Request.delete(`${resource}/deletefilleditembyid?idItem=${id}`, token);
        });
    },
};
